<template>
  <div>
    <logged-in-header />
    <certificate-bar />
    <stores-panel />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import certificateBar from "../components/common/CertificateBar.vue";
import storesPanel from "../components/dashboard/StoresPanel.vue";

export default {
  components: {
    loggedInHeader,
    certificateBar,
    storesPanel
  }
};
</script>
